module.exports = __webpack_public_path__ + "static/media/tiRed.46161c23.svg";